import React from "react";
import { Link } from "react-router-dom";

import "../../Styles/Box.css";

function Box({ Boximg, Boxtext, Boxnumber, coundOfWard, disabled }) {
  return (
    <div className="Box">
      <div className="Box-inside-item-image">
        <img
          className="Box-inside-image"
          src={Boximg}
          style={disabled ? { filter: "grayscale(100%)" } : {}}
        />
      </div>

      <div className="Box-inside">
        <p className="Box-inside-text number-font"> {Boxtext} </p>
        <div className="Box-inside-item">
          <div className="Box-inside-item-border-text">
            <p className="Box-inside-item-text">
              {Boxnumber} تا الان:{" "}
              <span className="number-font">{coundOfWard}</span>
            </p>
          </div>
          <div className="Box-inside-item-border-button">
            <Link to={"/hisstori/club"} className="Box-inside-item-button">
              باشگاه
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

Box.defaultProps = {
  disabled: false,
};

export default Box;
